import { useEffect } from "react";

import { QuestionsExplorer } from "./QuestionsExplorer";
import { GettingStarted } from "./GettingStarted";
import { ClosingSection } from "./ClosingSection";
import { PAGE_TITLE } from "./constants";
import { WelcomeFooter } from "./WelcomeFooter";
import { WelcomeHeader } from "./WelcomeHeader";
import { WelcomeHero } from "./WelcomeHero";
import { Main, PageRoot, SkipLink, WelcomeScrollReset } from "./styles";

const MAIN_CONTENT_ID = "welcome-main";

export const WelcomePage: React.FC = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = PAGE_TITLE;
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <PageRoot id="top">
      <WelcomeScrollReset />
      <SkipLink href={`#${MAIN_CONTENT_ID}`}>Skip to content</SkipLink>
      <WelcomeHeader />
      <Main id={MAIN_CONTENT_ID} tabIndex={-1}>
        <WelcomeHero />
        <QuestionsExplorer />
        <GettingStarted />
        <ClosingSection />
      </Main>
      <WelcomeFooter />
    </PageRoot>
  );
};
